<template>
    <div>
        <b-card no-body>
            <b-card-header>
                <span class="h5">
                    TIPO DE MOVIMENTO -
                    {{ operacao == 'DETALHAR' ? `${codMov} - ` : '' }}
                    <b-badge variant="warning">{{ operacao }}</b-badge>
                </span>
            </b-card-header>
            <b-card-body>
                <app-erros-box
                    :erros="erros"
                    v-if="erros.length > 0"
                ></app-erros-box>
                <b-row v-if="operacao == 'INSERIR'">
                    <b-col sm="12" md="2">
                        <b-form-group>
                            <label class="required"
                                >Cód. Movimento <small>(CODTMV)</small></label
                            >
                            <b-input-group>
                                <b-form-input
                                    type="text"
                                    v-model="codMov"
                                    :disabled="desabilitarForm"
                                ></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="4">
                        <b-form-group>
                            <label class="required">Nome do movimento</label>
                            <b-input-group>
                                <b-form-input
                                    type="text"
                                    v-model="nomeTipoMovimento"
                                    :disabled="desabilitarForm"
                                ></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="3">
                        <b-form-group>
                            <label class="required">
                                Etapa do movimento
                            </label>
                            <b-form-select
                                :options="etapasMovimento"
                                v-model="etapaMovimento"
                                text-field="descricao"
                                value-field="codigo"
                                :disabled="!operacaoInsercao"
                            ></b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row>
                <div v-if="operacao != 'INSERIR'">
                    <ul class="list-group">
                        <li
                            class="list-group-item"
                            v-for="arquivo in arquivosXml"
                            :key="arquivo"
                        >
                            <btn-inserir-documento
                                :documento="{ codMov: codMov, tipo: arquivo }"
                            ></btn-inserir-documento>
                            <btn-download-documento
                                v-if="operacao == 'DETALHAR'"
                                :documento="{ codMov: codMov, tipo: arquivo }"
                            ></btn-download-documento>
                            {{ arquivo }}
                        </li>
                    </ul>
                </div>
            </b-card-body>
            <b-card-footer>
                <app-btn-voltar class="float-left mr-2"></app-btn-voltar>
                <btn-salvar
                    v-if="operacao == 'INSERIR'"
                    class="float-left"
                    :operacao="operacao"
                    :tipoMovimento="tipoMovimento"
                    :desabilitarSalvar="$v.$invalid"
                    @atualizarErros="erros = $event"
                    @obterTiposMovimentosAtualizados="obterTiposMovimentos()"
                >
                </btn-salvar>
            </b-card-footer>
        </b-card>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import TiposMovimentosServicos from './TiposMovimentosServicos'
import BtnSalvar from './BtnSalvar'
import BtnInserirDocumento from './BtnInserirDocumento'
import BtnDownloadDocumento from './BtnDownloadDocumento'

export default {
    components: {
        BtnSalvar,
        BtnInserirDocumento,
        BtnDownloadDocumento
    },

    props: {},

    data() {
        return {
            erros: [],
            codMov: '',
            nomeTipoMovimento: null,
            arquivosXml: [
                'TMOV',
                'TMOVCOMPL',
                'TMOVHISTORICO',
                'TITMMOV',
                'TITMMOVRATCCU'
            ],
            etapasMovimento: [],
            etapaMovimento: null
        }
    },

    methods: {
        obterTipoMovimento() {
            this.$store.dispatch('addRequest')
            TiposMovimentosServicos.obterTipoMovimento(
                this.$route.params.codMov
            ).then(response => {
                if (response) {
                    if (response.success) {
                        this.preencherFormulario(response.data)
                    } else {
                        this.$toast.error(
                            'Erro ao obter vendedores',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterOpcoes() {
            this.$store.dispatch('addRequest')
            TiposMovimentosServicos.obterOpcoes().then(response => {
                if (response) {
                    if (response.success) {
                        this.preencherOpcoes(response.data)
                    } else {
                        this.$toast.error(
                            'Erro ao obter opções de escolha da interface',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        preencherFormulario(data) {
            this.codMov = data.codTipoMovimento
        },

        preencherOpcoes(data) {
            this.etapasMovimento = data.etapaMovimentoDto
        },

        obterTiposMovimentos() {
            this.$emit('obterTiposMovimentos')
            this.$router.push({
                name: 'TiposMovimentos'
            })
        },

        camposAutomaticos(tipo) {
            switch (tipo) {
                case 'TMOV':
                    return this.camposAutomaticosTMOV
                    break
                case 'TMOVCOMPL':
                    return this.camposAutomaticosTMOVCOMPL
                    break
                case 'TMOVHISTORICO':
                    return this.camposAutomaticosTMOVHISTORICO
                    break
                case 'TITMMOV':
                    return this.camposAutomaticosTITMMOV
                    break
                case 'TITMMOVRATCCU':
                    return this.camposAutomaticosTITMMOVRATCCU
                    break
                default:
                    return []
                    break
            }
        }
    },

    created() {
        if (this.operacao == 'INSERIR') {
            this.obterOpcoes()
        } else if (this.operacao == 'DETALHAR') {
            this.obterTipoMovimento()
        }
    },

    computed: {
        operacao() {
            if (this.$route.name == 'TiposMovimentos_Inserir') {
                return 'INSERIR'
            } else if (this.$route.name == 'TiposMovimentos_Detalhar') {
                return 'DETALHAR'
            }
        },

        operacaoInsercao() {
            return this.operacao === 'INSERIR'
        },

        desabilitarForm() {
            return this.operacao == 'DETALHAR'
        },

        tipoMovimento() {
            return {
                codMov: this.codMov,
                nomeTipoMovimento: this.nomeTipoMovimento,
                tipoMovimentoEtapa: this.etapaMovimento
            }
        }
    },

    watch: {},

    validations: {
        codMov: {
            required
        },
        nomeTipoMovimento: {
            required
        },
        etapaMovimento: {
            eInsercao() {
                if (this.operacaoInsercao) {
                    return this.etapaMovimento != null
                }
                return true
            }
        }
    }
}
</script>
